export class Supplier {
    constructor(
      public id: number,
      public name: string
    ) { }
  }
  